import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { JqueryUtils } from '../../utils/jquery.utils';
import { StrategyService } from '../../services/api/strategy.service';

import { NotificationService } from '../../services/notification.service';
import { CONSTANTS } from '../../constants';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-entity-strategy',
  templateUrl: './strategy.component.html',
  styleUrls: ['./strategy.component.scss'],
})

export class StrategyComponent implements OnInit {

  offset = 0;
  count = 20;
  totalPages = 0;
  totalItems = 0;
  selectedItemPerPage = 0;
  pageNumber = 0;

  script_types: any = CONSTANTS.SCRIPT_TYPES;
  strategies: any[] = [];
  modalHeader = '';
  modal_strategy: any = {};
  cm_params: any = { };
  admin: any;

  confirmationParams: any = { type: '', action: '', action_class: {}, strategy: null };

  strategy_modal_form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    display_name: new FormControl('', [Validators.required]),
    strategy_type: new FormControl('', [Validators.required]),
    config_capital_buy: new FormControl('', [Validators.required]),
    config_capital_sell: new FormControl('', [Validators.required]),
    script: new FormControl('', [Validators.required]),
    script_details: new FormControl(''),
  });

  constructor(private strategyService: StrategyService, private dataService: DataService,
    private jq: JqueryUtils, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.ENTITY_STRATEGY});
    this.listStrategies();
  }

  listStrategies(data = {}) {
    this.strategyService.listStrategies().subscribe((response: any) => {
      let strats = response.strategies;
      let strategies: any = [];
      let strat;
      for (let idx = 0; idx < strats.length; idx++) {
        strat = strats[idx];
        if (strat.state == 'active') {
          strat.state_class = { 'bi-person-check-fill': 1, 'bi-person-fill': 0, 'text-success': 1 }
        } else {
          strat.state_class = { 'bi-person-check-fill': 0, 'bi-person-fill': 1, 'text-success': 0 }
        }
        strategies.push(strat);
      }
      this.strategies = strategies;
    });
  }

  onActivate(strategy: any) {
    this.cm_params = {
      msg: `Are you sure want to ${strategy.state == 'active' ? 'deactivate' : 'activate'} this user ?`,
      tag: strategy.name,
      btn_text: (strategy.state == 'active') ? 'DEACTIVATE' : 'ACTIVATE',
      btn_class: (strategy.state == 'active') ? {'btn-success': 0, 'btn-danger':1} : {'btn-success': 1, 'btn-danger':0},
      action: 'activate',
      details: {
        _id: strategy._id,
        state: (strategy.state == 'active') ? 0 : 1
      }
    }
    this.jq.openModal('confirmationStrategyDeleteModal');
  }

  saveStrategy() {
    let script_details: any = {};
    try {
      script_details = JSON.parse(this.strategy_modal_form.value.script_details!);
    } catch { }
    if (this.modal_strategy.mode == 'add') {
      let data = {
        name: this.strategy_modal_form.value.name,
        display_name: this.strategy_modal_form.value.display_name,
        type: this.strategy_modal_form.value.strategy_type,
        config: {
          capital: {
            buy: this.strategy_modal_form.value.config_capital_buy,
            sell: this.strategy_modal_form.value.config_capital_sell
          }
        },
        script: this.strategy_modal_form.value.script,
        script_details: script_details
      };
      this.strategyService.addStrategy(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.jq.closeModal('strategyModal');
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Strategy added successfully")
          this.listStrategies();
        }
      });
    } else if (this.modal_strategy.mode == 'edit') {
      let data = { 
        strategy_id: this.modal_strategy.strategy._id,
        name: this.strategy_modal_form.value.name,
        display_name: this.strategy_modal_form.value.display_name,
        type: this.strategy_modal_form.value.strategy_type,
        config: {
          capital: {
            buy: this.strategy_modal_form.value.config_capital_buy,
            sell: this.strategy_modal_form.value.config_capital_sell
          }
        },
        script: this.strategy_modal_form.value.script,
        script_details: script_details
      };
      this.strategyService.updateStrategy(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.jq.closeModal('strategyModal');
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Strategy updated successfully")
          this.listStrategies();
        }
      });
    }
  }

  onAdd() {
    this.modalHeader = 'Add Strategy';
    this.modal_strategy = { header: 'Add Strategy', btn_text: 'ADD', mode: 'add' };
    this.strategy_modal_form.patchValue({
      name: '',
      display_name: '',
      strategy_type: '',
      config_capital_buy: '',
      config_capital_sell: '',
      script: '',
      script_details: ''
    });
    this.jq.openModal('strategyModal');
  }

  onUpdate(strategy: any) {
    this.modal_strategy['mode'] = 'edit';
    this.modal_strategy['header'] = 'Update Strategy';
    this.modal_strategy['btn_text'] = 'UPDATE';
    this.modal_strategy['strategy'] = strategy;
    this.modal_strategy['_id'] = strategy._id;
    this.strategy_modal_form.patchValue({
      name: strategy.name,
      display_name: strategy.display_name,
      strategy_type: strategy.type,
      config_capital_buy: strategy.config?.capital?.buy,
      config_capital_sell: strategy.config?.capital?.sell,
      script: strategy.script,
      script_details: strategy.script_details,
    });
    this.jq.openModal('strategyModal');
  }

  onStatusClick(event: any, strategy: any) {
    this.jq.openModal('strategyConfirmationModal');
    this.confirmationParams = { 
      message: `Are you sure want to ${strategy.state == 'active' ? 'deactivate' : 'activate'} this strategy?`,
      action: strategy.state == 'active' ? 'Inactive' : 'Active',
      user_action: 'state',
      action_class: strategy.enabled== 'active' ? { 'btn-danger': 0, 'btn-success': 1 } : { 'btn-danger': 1, 'btn-success': 0 },
      strategy: strategy,
      target: event.target
    };
  }

  onScopeClick(event: any, strategy: any) {
    this.jq.openModal('strategyConfirmationModal');
    this.confirmationParams = { 
      message: `Are you want to make this strategy ${strategy.scope == 'public'? 'private': 'public'}?`,
      action: strategy.scope == 'private'? 'PUBLIC' : 'PRIVATE',
      user_action: 'scope',
      action_class: strategy.scope == 'private' ? { 'btn-danger': 0, 'btn-success': 1 } : { 'btn-danger': 1, 'btn-success': 0 },
      strategy: strategy,
      target: event.target
    };
  }

  updateStrategyStatus(confirmation: any, params: any) {
    if (confirmation == 1) {
      let data: any, func: any;
      if (params.user_action == 'state') {
        data = { _id: params.strategy._id, state: params.action.toLowerCase() };
        func = this.strategyService.updateStrategyState;
      } else if (params.user_action == 'scope') {
        data = { _id: params.strategy._id, scope: params.action.toLowerCase() };
        func = this.strategyService.updateStrategyScope;
      }
      func(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, `Updated Successfully`);
          this.jq.closeModal('strategyConfirmationModal')
        }
        this.listStrategies();
      });
    } else {
      if (params.user_action == 'status') {
        this.confirmationParams.target.checked = params.strategy.status == 'inactive';
      } else if (params.user_action == 'scope') {
        this.confirmationParams.target.checked = params.strategy.scope.toUpperCase() == 'PUBLIC';
      }
      this.confirmationParams = { message: '', user_action: '',  action: '', action_class: {}, strategy: null } ;
      this.jq.closeModal('strategyConfirmationModal')
    }
  }

  onModalClose(modal_name: string) {
    if (modal_name == 'strategy') {
      this.modal_strategy = { header: '', btn_text: '', name: '', email: '', phone: '', subscription_upto: '', password: '' };
      this.jq.closeModal('strategyModal');
    } else if (modal_name == 'confirmation_strategy_delete') {
      this.jq.closeModal('confirmationStrategyDeleteModal');
    }
  }

  onDelete(strategy: any) {
    this.cm_params = {
      msg: 'Are you sure want to delete this strategy ?',
      tag: strategy.name,
      btn_text: 'DELETE',
      action: 'delete',
      details: {
        _id: strategy._id
      }
    }
    this.jq.openModal('confirmationStrategyDeleteModal');
  }

  onConfirm() {
    if (this.cm_params.action == 'confirmation_strategy_delete') {
      let input = { "_id": this.cm_params.details._id, "state": this.cm_params.details.state };
      this.strategyService.deleteStrategy(input).subscribe((response: any) => {
        if (this.cm_params.details.state == 1) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Strategy Activated successfully");
        } else {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Strategy Deactivated successfully");
        }
        this.cm_params = { };
        this.jq.closeModal('confirmationStrategyDeleteModal');
        this.listStrategies();
      });
    }
  }

  compareScript(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  get name() {
    return this.strategy_modal_form.get('name') as FormControl
  }

  get name_errors() {
    return (this.strategy_modal_form.get('name') as FormControl).errors as ValidationErrors
  }

  get display_name() {
    return this.strategy_modal_form.get('display_name') as FormControl
  }

  get display_name_errors() {
    return (this.strategy_modal_form.get('display_name') as FormControl).errors as ValidationErrors 
  }

  get strategy_type() {
    return this.strategy_modal_form.get('strategy_type') as FormControl
  }

  get strategy_type_errors() {
    return (this.strategy_modal_form.get('strategy_type') as FormControl).errors as ValidationErrors
  }

  get config_capital_buy() {
    return this.strategy_modal_form.get('config_capital_buy') as FormControl
  }

  get config_capital_buy_errors() {
    return (this.strategy_modal_form.get('config_capital_buy') as FormControl).errors as ValidationErrors
  }

  get config_capital_sell() {
    return this.strategy_modal_form.get('config_capital_sell') as FormControl
  }

  get config_capital_sell_errors() {
    return (this.strategy_modal_form.get('config_capital_sell') as FormControl).errors as ValidationErrors
  }

  get script() {
    return this.strategy_modal_form.get('script') as FormControl
  }

  get script_errors() {
    return (this.strategy_modal_form.get('script') as FormControl).errors as ValidationErrors
  }

  get script_details() {
    return this.strategy_modal_form.get('script') as FormControl
  }

  get script_details_errors() {
    return (this.strategy_modal_form.get('script_details') as FormControl).errors as ValidationErrors
  }

  next() { }
  prev() { }
}
